import dashboardES from './dashboard';
import menuAboutES from './menuAbout';
import labelsES from './labels';
import releasesES from './releases';
import artistsES from './artists';
import artistsWishlistES from './artistsWishlist';
import profileES from './profile';
import musicLinksES from './musicLinks';
import linkLandingPagesES from './linkLandingPages';
import masteringES from './mastering';
import featureES from './feature';
import accountingES from './accounting';
import paymentMethodsES from './paymentMethods';
import purchaseHistoryES from './purchaseHistory';
import trendsES from './trends';
import earningsDrilldownES from './earningsDrilldown';
import invoicesES from './invoices';
import statementsES from './statements';
import subuserStatementsES from './subuserStatements';
import userDataFormES from './userDataForm';
import creditsES from './credits';
import disputeClaimsES from './disputeClaims';
import musicLinkUrlPartsES from './musicLinkUrlParts';
import subscriptionES from './subscription';
import twoFactorAuthES from './twoFactorAuth';
import generalES from './general';
import routerES from './router';
import escrowWalletES from './escrowWallet';
import subUsersES from './subUsers';
import tokensES from './tokens';
import tracksES from './tracks';
import acrAlertES from './acrAlert';
import qcNoteES from './qcNote';
import flaggedContentES from './flaggedContent';
import deliveryConfirmationES from './deliveryConfirmation';
import preScanES from './preScan';
import accessKeysES from './accessKeys';
import announcementsES from './announcements';

const translationES = {
    'router': routerES,
    'general': generalES,
    'dashboard': dashboardES,
    'menuAbout': menuAboutES,
    'labels': labelsES,
    'artists': artistsES,
    'artistsWishlist': artistsWishlistES,
    'releases': releasesES,
    'tracks': tracksES,
    'profile': profileES,
    'musicLinks': musicLinksES,
    'musicLinkUrlParts': musicLinkUrlPartsES,
    'linkLandingPages': linkLandingPagesES,
    'mastering': masteringES,
    'feature': featureES,
    'accounting': accountingES,
    'paymentMethods': paymentMethodsES,
    'purchaseHistory': purchaseHistoryES,
    'trends': trendsES,
    'earningsDrilldown': earningsDrilldownES,
    'invoices': invoicesES,
    'statements': statementsES,
    'subuserStatements': subuserStatementsES,
    'credits': creditsES,
    'userDataForm': userDataFormES,
    'disputeClaims': disputeClaimsES,
    'subscription': subscriptionES,
    'twoFactorAuth': twoFactorAuthES,
    'escrowWallet': escrowWalletES,
    'subUsers': subUsersES,
    'tokens': tokensES,
    'acrAlert': acrAlertES,
    'qcNote': qcNoteES,
    'flaggedContent': flaggedContentES,
    'deliveryConfirmation': deliveryConfirmationES,
    'preScan': preScanES,
    'accessKeys': accessKeysES,
    'announcements': announcementsES,
};

export default translationES;
